import Card from "./card.js";
import Banner from "./banner.js";
export default class ImageOnly extends Banner {
  constructor(s, t, i, h, r, e, a, n, o, c, m, b, l, p) {
    super(s, t, i, h, r, e, a, n, o, c, m, b, l, p),
      (this.U = "ab-banner ab-image-only"),
      (this.V = !1),
      (this.test = !1);
  }
  ss() {
    const s = {};
    return (
      (s[Card.hs.ts] = Card.es.rs),
      (s[Card.hs.ns] = this.id),
      (s[Card.hs.ls] = this.viewed),
      (s[Card.hs.os] = this.imageUrl),
      (s[Card.hs.us] = this.updated),
      (s[Card.hs.cs] = this.created),
      (s[Card.hs.bs] = this.categories),
      (s[Card.hs.ds] = this.expiresAt),
      (s[Card.hs.URL] = this.url),
      (s[Card.hs.ps] = this.linkText),
      (s[Card.hs.fs] = this.aspectRatio),
      (s[Card.hs.xs] = this.extras),
      (s[Card.hs.gs] = this.pinned),
      (s[Card.hs.js] = this.dismissible),
      (s[Card.hs.ys] = this.clicked),
      (s[Card.hs.zs] = this.test),
      s
    );
  }
}
